import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgSignatureComponent} from '../../misc/exg-signature/exg-signature.component';

@Component({
  selector: 'app-modal-calculation-signature',
  templateUrl: './modal-calculation-signature.component.html',
  styles: []
})
export class ModalCalculationSignatureComponent extends ExcTranslation implements OnInit {

  @ViewChild('sigPad1') sigPad1!: ExgSignatureComponent;
  @Input() data: any;

  isLoading = false;

  currentStep: 'vn' | 'entgegen' = 'vn';
  signatureVN?: string;
  signatureEntgegen?: string;

  title = 'Schlusserklärung unterschreiben';
  labelVN = 'Versicherungsnehmer';
  labelEntgegen = 'Entgegengenommen';
  captionEntgegen = '';

  constructor(
    private modalService: ExgModalService,
    public excSecurity: ExcSecurityService
  ) {
    super();
  }

  ngOnInit(): void {
    this.title = this.data?.title;
    this.labelVN = this.data?.labelVN;
    this.labelEntgegen = this.data?.labelEntgegen;
    this.captionEntgegen = this.data?.captionEntgegen || this.excSecurity.UserName;
  }

  deleteImage1(): void {
    this.sigPad1.clear();
    if (this.currentStep === 'vn') {
      this.signatureVN = undefined;
    } else {
      this.signatureEntgegen = undefined;
    }
  }

  handleHasImage1(): void {
    const canvas = this.sigPad1.nativeElement();
    if (!canvas) {
      return;
    }

    const scaleFactor = 3;

    const scaledCanvas = document.createElement('canvas');
    scaledCanvas.width = canvas.width * scaleFactor;
    scaledCanvas.height = canvas.height * scaleFactor;

    const x = scaledCanvas.getContext('2d');
    if (!x) {
      return;
    }

    x.scale(scaleFactor, scaleFactor);
    x.drawImage(canvas, 0, 0);

    const dataUrl = scaledCanvas.toDataURL('image/png');

    if (this.currentStep === 'vn') {
      this.signatureVN = dataUrl;
    } else {
      this.signatureEntgegen = dataUrl;
    }
  }
  saveAndContinue(): void {
    if (!this.signatureVN) {
      return;
    }
    this.sigPad1.clear();
    this.currentStep = 'entgegen';
  }

  saveAndGeneratePDF(): void {
    if (!this.signatureVN || !this.signatureEntgegen) {
      return;
    }
    this.modalService.action({
      signatureVN: this.signatureVN,
      signatureEntgegen: this.signatureEntgegen
    });
  }

  close(): void {
    this.modalService.close();
  }
}
